import { translate } from "@classdojo/web/utils/translate";
import icon from "./assets/logo.svg";
import { Question } from "./types";
import createToolPod from "src/infra/createToolPod";

export const appMetadataPairshare = () => ({
  href: "pairshare",
  title: translate("dojo.toolkit:apps.think_pair_share"),
  backgroundColor: "dt_content_accent" as const,
  icon,
  closeButtonStyle: { color: "dt_content_primary" as const },
});

const STATE_KEY = "pairshare";
export const { install, action: RECEIVE_QUESTION } = createToolPod(STATE_KEY, "RECEIVE_QUESTION");
export default install;

export type PairShareState = {
  question: Question;
};

export type PairShareSlice = {
  [STATE_KEY]: PairShareState;
};
